import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersBenchmarkingSelector = createSelector(
    statsLeadersSelector,
    (statsLeaders) => statsLeaders.benchmarking
);
